<template>
  <div>
    <!-- 检索区域 -->
    <div class="bg-content padding15 margin15-tb">
      <el-form size="small" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="发送节点">
              <el-select v-model="strategyType" placeholder="请选择" clearable style="width: 100%;">
                <el-option label="电话前" :value="1"></el-option>
                <el-option label="电话中" :value="2"></el-option>
                <el-option label="电话后" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="挂短名称">
              <el-input v-model="name" clearable placeholder="请输入挂短名称" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="短信模板名称">
              <el-input v-model="templateName" clearable placeholder="请输入短信模板名称" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="短信模板内容">
              <el-input v-model="templateContent" clearable placeholder="前后加上#可检索参数" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="状态">
              <el-select v-model="status" placeholder="请选择" clearable style="width: 100%;">
                <el-option label="开启" :value="1"></el-option>
                <el-option label="关闭" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <div class="text right">
              <el-button type="primary" size="small" @click="search">查询</el-button>
              <el-button size="small" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 列表 + 操作 -->
    <div class="bg-content padding15">
      <div class="table-header">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增挂短模板</el-button>
        <el-button class="unbind-strategy-btn" size="small" @click="openUnbindStrategyDialog" :disabled="selectedRows.length === 0">
          <svg class="unlink-icon" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m18.84 12.25 1.72-1.71a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"></path>
            <path d="m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"></path>
            <line x1="8" y1="2" x2="8" y2="5"></line>
            <line x1="2" y1="8" x2="5" y2="8"></line>
            <line x1="16" y1="19" x2="16" y2="22"></line>
            <line x1="19" y1="16" x2="22" y2="16"></line>
          </svg>
          解绑策略
        </el-button>
      </div>
      <el-table :data="tableData" border size="small" style="width: 100%;" v-loading="loading"
                @selection-change="onSelectionChange" @row-click="handleRowClick" ref="hangupTable">
        <el-table-column type="expand" width="0" class="hangup-expand-col">
          <template slot-scope="props">
            <div class="rule-expand" v-if="props.row.rules && props.row.rules.length" @click.stop>
              <el-table :data="props.row.rules" border size="small" style="width: 100%;">
                <el-table-column label="标签类型" align="center" min-width="110">
                  <template slot-scope="s">{{ formatLabelType(s.row.labelType) }}</template>
                </el-table-column>
                <el-table-column label="标签值" align="center" min-width="160">
                  <template slot-scope="s">{{ formatLabelValue(s.row) }}</template>
                </el-table-column>
                <el-table-column label="电话状态" align="center" min-width="170">
                  <template slot-scope="s">{{ formatRuleMobileStatus(s.row) }}</template>
                </el-table-column>
                <el-table-column label="短信模板名称" align="center" min-width="160">
                  <template slot-scope="s">{{ templateNameOf(s.row) }}</template>
                </el-table-column>
                <el-table-column label="短信模板内容" align="center" min-width="280">
                  <template slot-scope="s">
                    <el-tooltip placement="top" effect="light" v-if="internationalVersionFlag === 1">
                      <div v-if="languageSelect === '0'" class="tpl-content" v-html="tplTransFallbackMain(s.row)"></div>
                      <div v-else class="tpl-content" v-html="tplContent(s.row)"></div>
                      <div v-if="languageSelect === '0'" slot="content" v-html="tplContent(s.row)"></div>
                      <div v-else slot="content" v-html="tplTransFallbackTip(s.row)"></div>
                    </el-tooltip>
                    <div class="tpl-content" v-html="formatTemplateContent(s.row)" v-else></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="rule-expand-empty" v-else @click.stop>暂无规则</div>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column prop="name" label="挂短名称" min-width="160" align="center"></el-table-column>
        <el-table-column label="发送节点" min-width="120" align="center">
          <template slot-scope="scope">
            {{ formatStrategyType(scope.row.strategyType) }}
          </template>
        </el-table-column>
        <!-- 统计列：过程标签 / 系统总标签 / 映射标签 / 电话状态 -->
        <el-table-column label="过程标签" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="stat-cell">
              <template v-if="statList(scope.row, 'process').length">
                <div v-for="(item, i) in statList(scope.row, 'process')" :key="i" class="stat-line" :style="{ color: statColorOf(item) }">{{ item.text }}</div>
              </template>
              <span v-else class="stat-empty">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="系统总标签" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="stat-cell">
              <template v-if="statList(scope.row, 'final').length">
                <div v-for="(item, i) in statList(scope.row, 'final')" :key="i" class="stat-line" :style="{ color: statColorOf(item) }">{{ item.text }}</div>
              </template>
              <span v-else class="stat-empty">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="映射标签" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="stat-cell">
              <template v-if="statList(scope.row, 'intention').length">
                <div v-for="(item, i) in statList(scope.row, 'intention')" :key="i" class="stat-line" :style="{ color: statColorOf(item) }">{{ item.text }}</div>
              </template>
              <span v-else class="stat-empty">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="电话状态" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="stat-cell">
              <template v-if="statList(scope.row, 'mobile').length">
                <div v-for="(item, i) in statList(scope.row, 'mobile')" :key="i" class="stat-line" :style="{ color: statColorOf(item) }">{{ item.text }}</div>
              </template>
              <span v-else class="stat-empty">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="180" align="center"></el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <span class="status-cell" @click.stop>
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                active-color="#49a1f6"
                @change="toggleStatus(scope.row)">
              </el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="handleEdit(scope.row)"><i class="el-icon-edit-outline"></i> 编辑</el-button>
            <el-button type="text" size="small" @click.stop="handleCopy(scope.row)"><i class="el-icon-document-copy"></i> 复制</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click.stop="openDeleteDialog(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-position">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增 / 编辑 / 复制 弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="760px" @close="dialogClose" custom-class="hangup-template-dialog">
      <div class="dialog-scroll">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="挂短名称" prop="name">
          <el-input v-model="form.name" clearable placeholder="请输入挂短名称" style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item label="发送节点" prop="strategyType">
          <el-select v-model="form.strategyType" placeholder="请选择" style="width: 100%;" :disabled="dialogType === 'edit'" @change="onStrategyTypeChange">
            <el-option label="电话前" :value="1"></el-option>
            <el-option label="电话中" :value="2"></el-option>
            <el-option label="电话后" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-color="#49a1f6"></el-switch>
        </el-form-item>

        <!-- 规则小卡片区（未选择发送节点时不展示） -->
        <div v-if="form.strategyType" class="rule-list">
          <div v-for="(rule, idx) in form.rules" :key="idx" class="rule-card">
            <div class="rule-card__header">
              <span class="rule-card__title">规则 {{ idx + 1 }}</span>
              <el-button type="text" class="rule-del" @click="removeRule(idx)"><i class="el-icon-delete"></i> 删除</el-button>
            </div>
            <div class="rule-card__body">
              <!-- 电话中：标签类型自动选中“过程标签”（后端传 3），不可改；标签内容为系统总标签多选 -->
              <template v-if="form.strategyType === 2">
                <el-form-item label="标签类型">
                  <el-select v-model="rule.labelType" placeholder="请选择" style="width: 100%;" disabled>
                    <el-option label="过程标签" :value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="标签内容">
                  <el-select v-model="rule.labelValue" multiple filterable collapse-tags
                             placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in labelOption" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <!-- 电话后：标签类型保持原两个选项，标签内容联动不变，电话状态仍可见 -->
              <template v-else-if="form.strategyType === 3">
                <el-form-item label="标签类型">
                  <el-select v-model="rule.labelType" placeholder="请选择" style="width: 100%;" @change="onLabelTypeChange(rule)">
                    <el-option label="系统总标签" :value="1"></el-option>
                    <el-option label="映射标签" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="标签内容">
                  <el-select v-if="rule.labelType === 1" v-model="rule.labelValue" multiple filterable collapse-tags
                             placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in labelOption" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                  <div v-else-if="rule.labelType === 2" class="mapping-tags">
                    <el-tag v-for="(tag, tIdx) in rule.labelValue" :key="tIdx" closable
                            @close="removeMapping(rule, tIdx)">{{ tag }}</el-tag>
                    <el-input v-if="rule.inputVisible" v-model="rule.inputValue" size="small" class="mapping-input"
                              @keyup.enter.native="confirmMapping(rule)" @blur="confirmMapping(rule)"></el-input>
                    <el-button v-else size="small" @click="showMappingInput(rule)">+ 新增</el-button>
                  </div>
                  <el-input v-else v-model="rule.labelValueText" placeholder="请先选择标签类型" disabled style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="电话状态">
                  <el-select v-model="rule.mobileStatus" multiple filterable collapse-tags
                             placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in mobileStatusOption" :key="item.modelCode"
                               :label="item.modelName" :value="item.modelCode"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <!-- 电话前：标签类型/标签内容/电话状态 全部隐藏，仅保留模板相关字段 -->
              <el-form-item label="模板名称">
                <el-select v-model="rule.templateId" filterable placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in templateMsgOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :title="item.name">
                    <el-tooltip effect="light" placement="top">
                      <div slot="content" v-html="item.content || item.templateContent || item.template || item.name"></div>
                      <span>{{ item.name }}</span>
                    </el-tooltip>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板内容" v-if="rule.templateId">
                <el-tooltip placement="top" effect="light" v-if="internationalVersionFlag === 1">
                  <div v-if="languageSelect === '0'" class="readonly-html" v-html="tplTransFallbackMain(rule)"></div>
                  <div v-else class="readonly-html" v-html="tplContent(rule)"></div>
                  <div v-if="languageSelect === '0'" slot="content" v-html="tplContent(rule)"></div>
                  <div v-else slot="content" v-html="tplTransFallbackTip(rule)"></div>
                </el-tooltip>
                <div class="readonly-html" v-html="tplContent(rule)" v-else></div>
              </el-form-item>
              <el-form-item label="是否解除上限">
                <el-switch v-model="rule.noLimit" active-color="#49a1f6" inactive-color="#C0C4CC"></el-switch>
              </el-form-item>
            </div>
          </div>
          <div class="rule-add">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addRule">新增规则</el-button>
          </div>
        </div>
      </el-form>
      </div>
      <!-- 规则检查预警：保存时检查接口返回非空预警则展示在保存/取消按钮上方 -->
      <div v-if="checkWarnings.length" class="check-warning">
        <div class="check-warning__title">请确认</div>
        <div v-for="(w, i) in checkWarnings" :key="i" class="check-warning__item">
          <span class="check-warning__label">{{ w.label }}：</span>
          <span class="check-warning__content">{{ w.items.join('；') }}</span>
        </div>
        <div class="check-warning__tip">提示：如确认无误，请再次点击保存可完成提交！</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="submitForm">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 解绑策略 二次确认弹框 -->
    <el-dialog title="解绑策略" :visible.sync="unbindStrategyVisible" width="480px" @close="unbindStrategyClose">
      <div class="unbind-strategy-tip">
        <i class="el-icon-warning"></i>
        <span>注意：解绑后将从所有绑定挂短模板的策略中移除此挂短模板！</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="unbindStrategyClose">取 消</el-button>
        <el-button class="unbind-strategy-btn" size="small" :loading="unbindStrategyLoading" @click="submitUnbindStrategy">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 删除挂短模板 二次确认弹框 -->
    <el-dialog title="删除挂短模板" :visible.sync="deleteVisible" width="480px" @close="deleteClose">
      <div class="unbind-strategy-tip">
        <i class="el-icon-warning"></i>
        <span>注意：删除操作将同步从策略中解绑此挂短模板！</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="deleteClose">取 消</el-button>
        <el-button class="unbind-strategy-btn" size="small" :loading="deleteLoading" @click="submitDelete">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const API = {
  page: '/hangupStrategy/getPage',
  save: '/hangupStrategy/edit',
  delete: '/hangupStrategy/delete',
  unbindByHangupIds: '/hangupStrategy/batchUnbindByHangupStrategyIds',
  detail: '/hangupStrategy/detail',
  updateStatus: '/hangupStrategy/updateStatus',
  ruleCheck: '/hangupStrategy/ruleCheck',
  templateParam: '/template/getTemplatesParam',
  labelParam: '/label/getLabelParams',
  mobileStatus: '/dict/list/washResult'
};

export default {
  props: {
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '挂短模板列表') {
        // 切到本 tab 时，从 props 兜底取一次公司/策略组（初次挂载时 watch 不会触发）
        this.companyId = this.companySelected;
        this.groupId = this.groupSelected;
        this.initOptions();
        this.getData(1);
      }
    },
    companySelected(val) {
      this.companyId = val;
      if (this.changeTabe === '挂短模板列表') {
        this.initOptions();
      }
    },
    groupSelected(val) {
      this.groupId = val;
      if (this.changeTabe === '挂短模板列表') {
        this.initOptions();
        this.getData(1);
      }
    },
    // 规则改动监听：仅 标签类型/标签内容/电话状态 三类字段（即 rulesSig 签名）变化才使 checkFlag 失效；
    // 模板名称(templateId)、是否解除上限(noLimit) 改动不影响签名，不触发 checkFlag 翻转
    'form.rules': {
      deep: true,
      handler() {
        const sig = this.buildRulesSignature();
        // 程序化回填（详情加载）或弹框未打开时：仅同步签名，不翻转 checkFlag
        if (this.suppressCheckWatch || !this.dialogVisible) {
          this.rulesSig = sig;
          return;
        }
        if (sig !== this.rulesSig) {
          this.checkFlag = false;
          this.checkWarnings = [];
        }
        this.rulesSig = sig;
      }
    }
  },
  // 与短信模板列表一致：companyId/groupId 来自父级 props（公司/策略组）。
  // 因本 tab 是懒加载，初次进入时 watch 不会触发，这里在挂载时兜底取一次，确保保存时不为空。
  created() {
    if (this.companySelected) this.companyId = this.companySelected;
    if (this.groupSelected) this.groupId = this.groupSelected;
  },
  mounted() {
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
  },
  beforeDestroy() {
    if (this.langChangeHandler) this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      // 检索字段
      strategyType: null,
      name: '',
      templateName: '',
      templateContent: '',
      status: null,
      // 来自父级（策略引擎顶部公司/策略组）
      companyId: '',
      groupId: '',
      // 下拉选项（切到本 tab 时初始化）
      templateMsgOption: [],
      labelOption: [],
      mobileStatusOption: [],
      // 下拉选项初始化守卫：记录已初始化过的 companyId|groupId，避免每次打开弹框重复请求
      optionsInited: false,
      optionInitKey: '',
      // 语言版本：国内版/国际版 + 当前语言（'0' 表示中文），用于短信模板内容多语言展示
      catchLanguageSelect: this.$getLanguageSelect(),
      // 弹窗
      dialogVisible: false,
      dialogType: 'add',
      dialogTitle: '新增挂短模板',
      submitLoading: false,
      dialogLoading: false,
      // ruleCheck 校验开关：true 表示已校验通过（可直接保存），false 表示需要走检查接口
      // 新增/复制场景初始 false，编辑场景初始 true；发送节点/标签类型/标签内容/电话状态 任意改动置 false
      checkFlag: false,
      // 检查接口返回的非空预警项（字段名 + 内容），仅在 checkFlag 被检查置 true 且有预警时展示
      checkWarnings: [],
      // 触发字段签名（仅含 标签类型/标签内容/电话状态）：用于精确判断规则改动是否影响 check，
      // 模板名称(templateId)、是否解除上限(noLimit) 不在签名中，改动不触发 checkFlag 翻转
      rulesSig: '',
      // 内部守卫：程序化回填表单（详情加载）期间抑制 check 相关 watch 翻转
      suppressCheckWatch: false,
      form: this.getEmptyForm(),
      rules: {
        name: [{ required: true, message: '请输入挂短名称', trigger: 'blur' }],
        strategyType: [{ required: true, message: '请选择发送节点', trigger: 'change' }]
      },
      // 列表多选 + 解绑策略
      selectedRows: [],
      unbindStrategyVisible: false,
      unbindStrategyLoading: false,
      // 删除二次确认
      deleteVisible: false,
      deleteRow: null,
      deleteLoading: false
    };
  },
  computed: {
    internationalVersionFlag() {
      return this.$getInternationalVersionFlag();
    },
    languageSelect() {
      return this.catchLanguageSelect;
    }
  },
  methods: {
    getEmptyForm() {
      return {
        id: '',
        name: '',
        strategyType: '',
        // 新增时状态默认启用（1=开启，0=关闭）
        status: 1,
        rules: []
      };
    },
    getEmptyRule() {
      return {
        id: '',
        labelType: 1,
        labelValue: [],
        mobileStatus: [],
        templateId: '',
        noLimit: false,
        inputVisible: false,
        inputValue: ''
      };
    },
    // 切到本 tab / 公司或策略组变化时初始化下拉选项（返回 Promise，便于编辑/复制回显前确保选项就绪）
    // 已针对当前 companyId|groupId 初始化过则直接跳过，避免每次打开新增/编辑/复制弹框都重复请求这 3 个接口
    initOptions() {
      if (!this.companyId && !this.groupId) return Promise.resolve();
      const key = `${this.companyId}|${this.groupId}`;
      if (this.optionInitKey === key && this.optionsInited) {
        return Promise.resolve();
      }
      const p1 = this.$ajax({
        url: API.templateParam,
        method: 'POST',
        data: { companyId: this.companyId, groupId: this.groupId, type: 'msg' }
      }).then((res) => {
        this.templateMsgOption = (res.data) || [];
      });
      const p2 = this.$ajax({
        url: API.labelParam,
        method: 'POST',
        data: { companyId: this.companyId }
      }).then((res) => {
        this.labelOption = (res.data) || [];
      });
      const p3 = this.$ajax({
        url: API.mobileStatus,
        method: 'GET'
      }).then((res) => {
        this.mobileStatusOption = (res.data) || [];
      });
      return Promise.all([p1, p2, p3]).then(() => {
        this.optionsInited = true;
        this.optionInitKey = key;
      });
    },
    // 父级策略引擎 search() 时会调用，用于联动刷新
    getDataByFirst(companyId, groupId, page) {
      this.companyId = companyId;
      this.groupId = groupId;
      this.getData(page || 1);
    },
    getSearchParam(page) {
      const model = {
        strategyType: this.strategyType === null || this.strategyType === '' ? undefined : this.strategyType,
        name: this.name || undefined,
        templateName: this.templateName || undefined,
        templateContent: this.templateContent || undefined,
        status: (this.status === null || this.status === '') ? undefined : this.status,
        companyId: this.companyId || undefined,
        groupId: this.groupId || undefined,
        // 分页查询默认携带统计参数，后端据此返回各标签/电话状态的统计信息
        needStatistics: true
      };
      return {
        pageQueryParam: {
          page,
          limit: this.pagination.limit
        },
        model
      };
    },
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: API.page,
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.tableData = (res.data && res.data.list) || [];
        this.pagination.total = (res.data && res.data.totalRecords) || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.getData(1);
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getData(val);
    },
    search() {
      this.pagination.page = 1;
      this.getData(1);
    },
    reset() {
      this.strategyType = null;
      this.name = '';
      this.templateName = '';
      this.templateContent = '';
      this.status = null;
      this.pagination.page = 1;
      this.getData(1);
    },
    formatStrategyType(val) {
      if (val === 1 || val === '1') return '电话前';
      if (val === 2 || val === '2') return '电话中';
      if (val === 3 || val === '3') return '电话后';
      return '-';
    },
    // 点击行任意区域展开/收起该行的规则子表格；选择列与展开箭头列不触发，避免双重切换
    handleRowClick(row, column) {
      if (column && (column.type === 'selection' || column.type === 'expand')) return;
      this.$refs.hangupTable.toggleRowExpansion(row);
    },
    // 状态列：开启/关闭。调用 /hangupStrategy/updateStatus，{ id, status }；失败则重新查询还原
    toggleStatus(row) {
      this.$ajax({
        url: API.updateStatus,
        method: 'POST',
        data: { id: row.id, status: row.status }
      }).catch(() => {
        this.getData(this.pagination.page);
      });
    },
    formatLabelType(val) {
      if (val === 1 || val === '1') return '系统总标签';
      if (val === 2 || val === '2') return '映射标签';
      if (val === 3 || val === '3') return '过程标签';
      return '-';
    },
    formatLabelValue(rule) {
      return this.toArray(rule.labelValue).join('、') || '-';
    },
    formatRuleMobileStatus(rule) {
      const arr = this.toArray(rule.mobileStatus);
      if (!arr.length) return '-';
      return arr.map((code) => {
        const found = this.mobileStatusOption.find(o => o.modelCode === code);
        return found ? found.modelName : code;
      }).join('、');
    },
    // 电话状态字典：modelCode -> modelName（统计列展示用）
    mobileStatusName(code) {
      const found = this.mobileStatusOption.find(o => String(o.modelCode) === String(code));
      return found ? found.modelName : code;
    },
    // 统计列：将后端返回的统计字段（nullCount + labelMap）转换为可展示项
    // type: process 过程标签 / final 系统总标签 / intention 映射标签 / mobile 电话状态
    //   - nullCount > 0：展示【有：x条未设置】
    //   - map 中 取值 > 1 的展示：【key：x条】（mobile 类型的 key 经字典转中文）
    // 颜色：2~5 条黄色，>5 条红色（由 statColor 决定）
    statList(row, type) {
      const conf = {
        process: { nullCount: 'processNullCount', map: 'processLabelMap' },
        final: { nullCount: 'finalLabelNullCount', map: 'finalLabelMap' },
        intention: { nullCount: 'intentionLabelNullCount', map: 'intentionLabelMap' },
        mobile: { nullCount: 'mobileStatusNullCount', map: 'mobileStatusMap', dict: true }
      }[type];
      if (!conf || !row) return [];
      const items = [];
      const nullCount = Number(row[conf.nullCount]) || 0;
      if (nullCount > 0) {
        // 未设置项固定红色，不受数量阈值影响
        items.push({ text: `${nullCount}条未设置`, count: nullCount, red: true });
      }
      const obj = row[conf.map];
      const entries = Array.isArray(obj) ? obj : Object.entries(obj || {});
      entries.forEach((pair) => {
        const key = Array.isArray(pair) ? pair[0] : pair;
        const val = Array.isArray(pair) ? pair[1] : pair;
        const count = Number(val) || 0;
        if (count > 1) {
          const displayKey = conf.dict ? this.mobileStatusName(key) : key;
          items.push({ text: `${displayKey}：${count}条`, count });
        }
      });
      return items;
    },
    // 统计项颜色：>5 条红色，2~5 条黄色，其余（含 1 条）中性灰
    statColor(count) {
      if (count > 5) return '#f56c6c';
      if (count >= 2) return '#e6a23c';
      return '#909399';
    },
    // 统计项最终取色：未设置项(red)强制红色，其余按 statColor 阈值
    statColorOf(item) {
      return item && item.red ? '#f56c6c' : this.statColor(item ? item.count : 0);
    },
    findTemplate(rule) {
      if (!rule || !rule.templateId) return null;
      return this.templateMsgOption.find(t => String(t.id) === String(rule.templateId)) || null;
    },
    templateNameOf(rule) {
      if (rule.templateName) return rule.templateName;
      const t = this.findTemplate(rule);
      return (t && (t.name || t.templateName)) || '-';
    },
    // 短信模板内容多语言展示：
    // 国内版 或 国际版且语言为中文 → templateContent ｜ templateContentTrans
    // 国际版且语言非中文 → templateContentTrans ｜ templateContent
    formatTemplateContent(rule) {
      const isInternational = this.internationalVersionFlag === 1;
      const isChinese = this.languageSelect === '0';
      const t = this.findTemplate(rule);
      const content = rule.templateContent || (t && (t.templateContent || t.content)) || '';
      const trans = rule.templateContentTrans || (t && (t.templateContentTrans || t.contentTrans)) || '';
      const parts = (!isInternational || isChinese) ? [content, trans] : [trans, content];
      return parts.filter(Boolean).join(' ｜ ') || '-';
    },
    // 模板原文（中文）内容：优先取规则内联字段，缺失回退 templateMsgOption
    tplContent(rule) {
      const t = this.findTemplate(rule);
      return rule.templateContent || (t && (t.templateContent || t.content)) || '';
    },
    // 模板翻译内容（中文界面主显示用）：缺失则回落“请补充中文翻译”+ 原文
    tplTransFallbackMain(rule) {
      const content = this.tplContent(rule);
      const t = this.findTemplate(rule);
      const trans = rule.templateContentTrans || (t && (t.templateContentTrans || t.contentTrans)) || '';
      return trans || `---请补充中文翻译---<br>${content}`;
    },
    // 模板翻译内容（非中文界面悬浮提示用）：缺失则回落“请补充中文翻译”
    tplTransFallbackTip(rule) {
      const t = this.findTemplate(rule);
      const trans = rule.templateContentTrans || (t && (t.templateContentTrans || t.contentTrans)) || '';
      return trans || '---请补充中文翻译---';
    },
    // 规则卡片操作
    onStrategyTypeChange() {
      // 用户改动发送节点 → 标记需要重新走检查接口
      this.checkFlag = false;
      this.checkWarnings = [];
      const st = this.form.strategyType;
      if (st && this.form.rules.length === 0) {
        this.form.rules.push(this.getEmptyRule());
      }
      if (st === 2) {
        // 电话中：标签类型自动选中“过程标签”(3)，标签内容改为系统总标签多选，清空旧值避免混入映射标签
        this.form.rules.forEach((r) => {
          r.labelType = 3;
          r.labelValue = Array.isArray(r.labelValue) ? r.labelValue : [];
        });
      } else if (st === 1) {
        // 电话前：隐藏标签类型/标签内容/电话状态，清空这些字段
        this.form.rules.forEach((r) => {
          r.labelType = '';
          r.labelValue = [];
          r.mobileStatus = [];
        });
      } else if (st === 3) {
        // 电话后：从电话中切回时，标签类型默认切回“映射标签”(2)，
        // 并清空标签内容/电话状态旧值，避免残留电话中的“过程标签”(3) 及多选值串味
        this.form.rules.forEach((r) => {
          r.labelType = 2;
          r.labelValue = [];
          r.mobileStatus = [];
          r.inputValue = '';
          r.inputVisible = false;
        });
      }
    },
    onLabelTypeChange(rule) {
      // 切换标签类型时清空已选标签内容，避免系统总标签/映射标签混用
      rule.labelValue = [];
      rule.inputValue = '';
      rule.inputVisible = false;
    },
    addRule() {
      const rule = this.getEmptyRule();
      // 电话中：新增规则时标签类型默认为“过程标签”(3)
      if (this.form.strategyType === 2) rule.labelType = 3;
      this.form.rules.push(rule);
    },
    removeRule(idx) {
      this.form.rules.splice(idx, 1);
    },
    showMappingInput(rule) {
      rule.inputVisible = true;
    },
    confirmMapping(rule) {
      const v = (rule.inputValue || '').trim();
      if (v && rule.labelValue.indexOf(v) === -1) {
        rule.labelValue.push(v);
      }
      rule.inputVisible = false;
      rule.inputValue = '';
    },
    removeMapping(rule, idx) {
      rule.labelValue.splice(idx, 1);
    },
    // 后端回显：把可能是数组或逗号字符串的值统一成数组
    toArray(val) {
      if (Array.isArray(val)) return val;
      if (typeof val === 'string' && val) return val.split(',').map(s => s.trim()).filter(Boolean);
      return [];
    },
    // 电话状态回显：兼容后端存 modelCode 数组 或 逗号拼接的 modelName 串
    resolveMobileStatus(val) {
      const arr = this.toArray(val);
      if (!arr.length) return [];
      return arr.map((s) => {
        const found = this.mobileStatusOption.find(o => o.modelName === s);
        return found ? found.modelCode : s;
      });
    },
    // 触发字段签名：仅取 标签类型/标签内容/电话状态，用于精确判断规则改动是否影响 check。
    // 模板名称(templateId)、是否解除上限(noLimit) 不计入，改动不触发 checkFlag 翻转
    buildRulesSignature() {
      return (this.form.rules || []).map((r) => {
        const label = this.toArray(r.labelValue);
        const mobile = this.toArray(r.mobileStatus);
        return [r.labelType, JSON.stringify(label), JSON.stringify(mobile)].join('|');
      }).join('::');
    },
    handleAdd() {
      this.dialogType = 'add';
      this.dialogTitle = '新增挂短模板';
      this.form = this.getEmptyForm();
      // 新增场景：checkFlag 初始 false（保存时需先走检查接口）
      this.checkFlag = false;
      this.checkWarnings = [];
      this.initOptions();
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogType = 'edit';
      this.dialogTitle = '编辑挂短模板';
      this.fetchDetail(row.id, 'edit');
    },
    handleCopy(row) {
      this.dialogType = 'copy';
      this.dialogTitle = '新增挂短模板';
      // 复制本质新增：先取详情，再清除 id 与 rules 内的 id
      this.fetchDetail(row.id, 'copy');
    },
    // 编辑/复制：均按 id 调详情接口拉取最新数据（复制时清除 id，作为新增提交）
    fetchDetail(id, type) {
      this.dialogLoading = true;
      Promise.resolve(this.initOptions()).then(() => this.$ajax({
        url: `${API.detail}/${id}`,
        method: 'GET'
      })).then((res) => {
        const data = (res && res.data) || {};
        const isCopy = type === 'copy';
        // 详情回填期间抑制 check 相关 watch，避免程序化赋值把 checkFlag 误置为 false
        this.suppressCheckWatch = true;
        this.form = {
          id: isCopy ? '' : (data.id || ''),
          name: data.name,
          strategyType: data.strategyType,
          // 状态：编辑/复制均继承源记录 status（1=开启，0=关闭）
          status: (data.status === 0 || data.status === 1) ? data.status : 1,
          // 乐观锁 version：编辑时原封带回（含 0，不能用 || 兜底否则会被清空），复制（新增）时不带
          version: isCopy ? '' : data.version,
          rules: (data.rules || []).map(r => ({
            id: isCopy ? '' : (r.id || ''),
            labelType: r.labelType,
            labelValue: this.toArray(r.labelValue),
            mobileStatus: this.resolveMobileStatus(r.mobileStatus),
            templateId: r.templateId,
            noLimit: !!r.noLimit,
            inputVisible: false,
            inputValue: ''
          }))
        };
        this.checkWarnings = [];
        // 编辑场景 checkFlag 初始 true（已校验过，保存可直接提交）；复制（本质新增）初始 false
        this.checkFlag = !isCopy;
        this.dialogLoading = false;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.suppressCheckWatch = false;
        });
      }).catch(() => {
        this.dialogLoading = false;
      });
    },
    openDeleteDialog(row) {
      this.deleteRow = row;
      this.deleteVisible = true;
    },
    deleteClose() {
      this.deleteVisible = false;
      this.deleteRow = null;
    },
    submitDelete() {
      if (!this.deleteRow) return;
      this.deleteLoading = true;
      this.$ajax({
        url: API.delete,
        method: 'POST',
        data: { id: this.deleteRow.id }
      }).then(() => {
        this.$message.success('删除成功');
        this.deleteVisible = false;
        this.deleteRow = null;
        this.deleteLoading = false;
        this.getData(this.pagination.page);
      }).catch(() => {
        this.deleteLoading = false;
      });
    },
    onSelectionChange(rows) {
      this.selectedRows = rows;
    },
    openUnbindStrategyDialog() {
      if (this.selectedRows.length === 0) return;
      this.unbindStrategyVisible = true;
    },
    unbindStrategyClose() {
      this.unbindStrategyVisible = false;
    },
    submitUnbindStrategy() {
      const hangupStrategyIds = this.selectedRows.map(item => item.id);
      this.unbindStrategyLoading = true;
      this.$ajax({
        url: API.unbindByHangupIds,
        method: 'POST',
        data: { hangupStrategyIds },
        prompt: true
      }).then(() => {
        this.unbindStrategyVisible = false;
        if (this.$refs.hangupTable) this.$refs.hangupTable.clearSelection();
        this.getData(this.pagination.page);
        this.unbindStrategyLoading = false;
      }).catch(() => {
        this.unbindStrategyLoading = false;
      });
    },
    dialogClose() {
      this.form = this.getEmptyForm();
      this.checkWarnings = [];
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    buildSaveData() {
      const st = this.form.strategyType;
      const rules = (this.form.rules || []).map((r) => {
        const rule = {
          id: r.id || undefined,
          templateId: r.templateId,
          noLimit: r.noLimit
        };
        if (st === 2) {
          // 电话中：标签类型固定为“过程标签”(3)，标签内容多选（系统总标签选项）
          rule.labelType = r.labelType || 3;
          rule.labelValue = (r.labelValue || []).join(',');
        } else if (st === 3) {
          // 电话后：标签类型（系统总标签/映射标签）+ 标签内容 + 电话状态，保持原逻辑
          rule.labelType = r.labelType;
          rule.labelValue = (r.labelValue || []).join(',');
          rule.mobileStatus = (r.mobileStatus || []).join(',');
        }
        // 电话前(st===1)：不提交标签类型/标签内容/电话状态
        return rule;
      });
      return {
        id: this.form.id || undefined,
        companyId: this.companyId,
        groupId: this.groupId,
        strategyType: this.form.strategyType,
        name: this.form.name,
        // 状态：1=开启，0=关闭（新增默认启用，编辑/复制继承源记录）
        status: this.form.status,
        // 乐观锁 version：编辑时原样回传（含 0），新增/复制时不带此字段
        version: this.dialogType === 'edit' ? this.form.version : undefined,
        rules
      };
    },
    // 将检查接口返回的统计字段按列表统计逻辑转换为预警项（仅系统总标签/映射标签/电话状态三项）
    buildCheckWarnings(data) {
      const types = [
        { key: 'process', label: '过程标签' },
        { key: 'final', label: '系统总标签' },
        { key: 'intention', label: '映射标签' },
        { key: 'mobile', label: '电话状态' }
      ];
      const result = [];
      types.forEach((t) => {
        const items = this.statList(data, t.key);
        if (items.length) {
          result.push({ label: t.label, items: items.map(i => i.text) });
        }
      });
      return result;
    },
    // 直接保存（checkFlag 已通过，或检查接口三项预警均为空）
    doSave() {
      this.submitLoading = true;
      this.$ajax({
        url: API.save,
        method: 'POST',
        data: this.buildSaveData()
      }).then(() => {
        this.dialogVisible = false;
        this.submitLoading = false;
        this.checkWarnings = [];
        this.getData(this.pagination.page);
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        // checkFlag 为 true：已校验通过，直接保存
        if (this.checkFlag) {
          this.doSave();
          return;
        }
        // checkFlag 为 false：先调检查接口（不弹成功提示），参数与提交一致
        this.submitLoading = true;
        this.$ajax({
          url: API.ruleCheck,
          method: 'POST',
          data: this.buildSaveData()
        }).then((res) => {
          const data = (res && res.data) || {};
          const warnings = this.buildCheckWarnings(data);
          if (warnings.length === 0) {
            // 三项预警均为空：直接立即保存
            this.doSave();
          } else {
            // 有预警：标记已检查，展示预警内容，等待用户再次点击保存
            this.checkWarnings = warnings;
            this.checkFlag = true;
            this.submitLoading = false;
          }
        }).catch(() => {
          this.submitLoading = false;
        });
      });
    }
  }
};
</script>

<style scoped>
.margin15-tb {
  margin-top: 15px;
  margin-bottom: 15px;
}

.bg-content {
  background: #fff;
  border-radius: 4px;
}

.padding15 {
  padding: 15px;
}

.text {
  display: flex;
  align-items: center;
}

.right {
  justify-content: flex-end;
}

.page-position {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.table-header {
  margin-bottom: 15px;
}

.dialog-footer {
  text-align: center;
}

.dialog-footer .el-button + .el-button {
  margin-left: 20px;
}

/* 解绑策略按钮：字大红、背景浅红（与列表删除色一致） */
.unbind-strategy-btn {
  color: #f56c6c;
  background-color: #fef0f0;
  border-color: #fde2e2;
}

.unbind-strategy-btn:hover,
.unbind-strategy-btn:focus {
  color: #f56c6c;
  background-color: #fde2e2;
  border-color: #fbc4c4;
}

/* 解绑图标：断开的链条（unlink），与 send_rule.vue 中“解绑挂短”图标一致 */
.unbind-strategy-btn .unlink-icon {
  margin-right: 5px;
  vertical-align: middle;
}

.unbind-strategy-btn.is-disabled,
.unbind-strategy-btn.is-disabled:hover {
  color: #f56c6c;
  background-color: #fef0f0;
  border-color: #fde2e2;
  opacity: 0.6;
}

/* 解绑策略二次确认提示 */
.unbind-strategy-tip {
  display: flex;
  align-items: flex-start;
  color: #e6a23c;
  font-size: 14px;
  line-height: 1.6;
}

.unbind-strategy-tip .el-icon-warning {
  color: #e6a23c;
  font-size: 18px;
  margin-right: 8px;
  margin-top: 2px;
}

/* 规则小卡片 */
.dialog-scroll {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;
}

.rule-list {
  border-top: 1px dashed #ebeef5;
  padding-top: 10px;
  margin-top: 6px;
}

.rule-card {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fafafa;
  margin-bottom: 14px;
  overflow: hidden;
}

.rule-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: #f0f2f5;
  border-bottom: 1px solid #e4e7ed;
}

.rule-card__title {
  font-weight: 600;
  color: #303133;
}

.rule-del {
  color: #f56c6c;
}

.rule-card__body {
  padding: 12px 14px 4px;
}

.rule-add {
  text-align: left;
  margin: 4px 0 10px;
}

/* 映射标签动态输入 */
.mapping-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

/* 展开行：规则子表格 */
.rule-expand {
  padding: 12px 24px;
  background: #ecf5ff;
}

/* 展开子表格整体淡蓝背景（主色 #49a1f6 的浅色档），与主表区分 */
.rule-expand .el-table,
.rule-expand .el-table__header-wrapper,
.rule-expand .el-table__body-wrapper,
.rule-expand .el-table th,
.rule-expand .el-table tr,
.rule-expand .el-table td {
  background: #ecf5ff;
}

/* 子表表头用稍深一档淡蓝，强化层次 */
.rule-expand .el-table__header-wrapper,
.rule-expand .el-table th {
  background: #d9ecff;
}

.rule-expand .el-table .cell {
  background: transparent;
}

/* 收起展开列的箭头图标与占位宽度，保留“点击行任意区域展开/收起”功能（handleRowClick） */
/deep/ .el-table__expand-column {
  width: 0 !important;
  min-width: 0 !important;
}

/deep/ .el-table__expand-column .cell,
/deep/ .el-table__expand-column .el-table__expand-icon {
  display: none !important;
}

/* 状态列：开关 */
.status-cell {
  display: inline-flex;
  align-items: center;
  cursor: default;
}

.rule-expand-empty {
  padding: 12px 24px;
  color: #909399;
  font-size: 13px;
  background: #ecf5ff;
}

/* 统计列：多个统计项纵向排列，按数量着色 */
.stat-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.stat-line {
  line-height: 1.5;
  word-break: break-all;
  white-space: normal;
}

.stat-empty {
  color: #909399;
}

.tpl-content {
  display: inline-block;
  max-width: 260px;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-all;
  vertical-align: middle;
}

/* 弹框内 模板内容（HTML 渲染容器），与 send_rule.vue 一致 */
.readonly-html {
  color: #606266;
  line-height: 1.6;
  word-break: break-all;
  white-space: normal;
}

/* 提交前规则检查预警块（展示在保存/取消按钮上方） */
.check-warning {
  margin: 0 0 14px;
  padding: 12px 16px;
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 1.8;
}

.check-warning__title {
  font-weight: 600;
  margin-bottom: 4px;
}

.check-warning__item {
  word-break: break-all;
}

.check-warning__label {
  font-weight: 600;
}

.check-warning__tip {
  margin-top: 6px;
  color: #e6a23c;
  font-weight: 600;
}

.mapping-input {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/hangup_template_list.vue